import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Form, Table} from 'semantic-ui-react';

import MultiPlatformField from '../../MultiPlatformField';
import {isNoU} from "utils/DBUtils";

{/* We need a custom component to display all current dropdown items in a table
  and let the user check off which ones a specific filtering result is mapped to */}
class AssociateItemsAndResultsTable extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        associatedItems: props.associatedItems(props.formProxy) ? props.associatedItems(props.formProxy) : []
      };
    }

    toggleItem = (itemId) => {

      let associatedItems = this.state.associatedItems;

      let itemIndex = associatedItems.indexOf(itemId);
      if (itemIndex > -1) {
        // remove
        associatedItems.splice(itemIndex, 1);
      }else {
        associatedItems.push(itemId);
      }
      this.setState({ associatedItems: associatedItems});

      this.props.onValueChanged(associatedItems, this.props.currentPlatform);
    }

    render() {
        let dropdowns = this.props.dropdowns(this.props.formProxy);
        return (
          <Fragment>
          {dropdowns ?
            <Table>
              <Table.Header>
                <Table.Row>
                  {dropdowns.map((dropdown, index) => {
                    return (
                      <Table.HeaderCell>{dropdown.label}</Table.HeaderCell>
                    )
                  })}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  {dropdowns.map((dropdown, index) => {
                    return (
                      <Table.Cell>
                        <ul>
                          {dropdown.items ?
                            dropdown.items.map((item, index) => {
                              return (
                                <Checkbox name='associatedItems'
                                          label={item.text ? item.text : "No Label"}
                                          value={item.value}
                                          checked={(this.state.associatedItems.indexOf(item.id) > -1)}
                                          onChange={(event, data) => this.toggleItem(item.id)}/>
                              )
                            })
                          : ""}
                        </ul>
                      </Table.Cell>
                    )
                  })}
                </Table.Row>
              </Table.Body>
            </Table>
          : "No Dropdowns Set" }
        </Fragment>
        );
    }
}

AssociateItemsAndResultsTable.propTypes = {};

export default AssociateItemsAndResultsTable;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/FilteringStep/AssociateItemsAndResultsTable.jsx